import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { BulkProposalCard } from './BulkProposalCard';
import type { SubmitProcurementPayload } from './proposal-part.types';

interface Props {
  proposalId: string;
  payload: SubmitProcurementPayload;
  /** Which document kind the card is about — decides the wording. */
  kind: 'requisitions' | 'purchaseOrders';
  resolved?: string | undefined;
  onConfirm: (proposalId: string) => void;
  onCancel: (proposalId: string) => void;
}

/** Confirmation card for handing draft requisitions or purchase orders over for approval. */
export function SubmitProcurementProposalCard({
  proposalId,
  payload,
  kind,
  resolved,
  onConfirm,
  onCancel
}: Props) {
  const t = useFeatureTranslation('aiChat');

  return (
    <BulkProposalCard
      title={t(`proposals.submit-procurement.${kind}.title`)}
      description={t(`proposals.submit-procurement.${kind}.countDescription`, {
        count: payload.documents.length
      })}
      proposalId={proposalId}
      rows={payload.documents}
      rowKey={row => row.id}
      primary={row => <span className='font-medium'>{row.number}</span>}
      resolved={resolved}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
